<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    //this.getAll();
  },
  computed: {
    pageCount() {
      return Math.ceil(
        this.$store.state.departments.totalItems / this.filters.pageSize
      );
    },
    rooms() {
      return [
        { value: 1, roomName: "الغرفة 1",floorName:"1", departmentName: "قسم التجميل" },
        { value: 2, roomName: "الغرفة 2 ",floorName:"1", departmentName: "قسم التجميل" },
        { value: 3, roomName: "الغرفة 2 ",floorName:"1", departmentName: "قسم الليزر" }
      ]
      // return this.$store.state.departments.departments;
    },
    departments() {
      return [
        { value: 1, label: "قسم التجميل" },
        { value: 2, label: "قسم الاسنان" },
        { value: 3, label: "قسم الليزر" }
      ]
    }
  },

  data() {
    return {
      view: 0,
      dialog: false,
      dialogType: null,
      dialogMessage: "",
      formDialog: false,
      room: {
        roomNo: null,
        departmentId: null,
      },
      filters: {
        page: 1,
        pageSize: 10,
        name: null,
      },

      headers: [
        { text: 'رقم الغرفة ', value: 'roomName' },
        { text: 'رقم الطابق ', value: 'floorName' },
        { text: 'اسم القسم ', value: 'departmentName' },
        // { text: 'منشأ بواسطة  ', value: 'createdBy' },
        // { text: 'تاريخ الانشاء  ', value: 'createdOn' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("departments/getAll", this.filters);
    },

    addItem() {
      this.view = 1;
      this.formDialog = true;
    },

    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
      this.formDialog = true;
      // Implement view logic
    },

    editItem(item) {
      this.itemId = item.id;
      this.department.name = item.name; //
      this.view = 2;
      this.formDialog = true;
      // Implement edit logic
    },
    deleteItem(item) {
      this.itemId = item.id;
      this.$store.dispatch(`departments/delete`, this.itemId);
    },
    back() {
      this.view = 0;
    },
    // --------------------------form dilog ------------------------------- //

    confirmFormDialog() {

      // this.$store
      //     .dispatch("administrations/add",{
      //         id:this.itemId,
      //         payload :this.department
      //     }) 
      //     .then(() => {
      //         this.cancelEmployee()
      //     })
      //     .catch(() => { });
      this.cancelFormDialog()
    },
    cancelFormDialog() {
      this.formDialog = false;
    },
    // // -------------- end empDialog  -----
    showDialog(item, type) {
      switch (type) {
        case "delete":
          this.dialogMessage = "هل انت متأكد من رغبتك حذف البيانات";
          break;
        // case "lock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تجميد البيانات";
        //     break;
        // case "unlock":
        //     this.dialogMessage = "هل انت متأكد من رغبتك تفعيل البيانات";
        //     break;
      }
      this.dialogType = type;
      this.itemId = item.id;
      this.dialog = true;
    },

    confirmDialog() {
      this.$store.dispatch(`departments/${this.dialogType}`, this.itemId);
      this.cancelDialog();
    },

    cancelDialog() {
      this.dialog = false;
      this.itemId = 0;
      this.dialogMessage = "";
      this.dialogType = null;
    },

  },
};
</script>

<style scoped></style>